function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "mobile_prototyping");

var _ref3 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 952.02997,
  cy: 736.35644,
  rx: 123,
  ry: 30,
  fill: "#3f3d56"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M583.82114,169.71864V566.72793a17.839,17.839,0,0,1-17.83862,17.83074H404.805a17.80758,17.80758,0,0,1-17.83857-17.83074V169.71864A17.83785,17.83785,0,0,1,404.805,151.88h24.12347v3.09517a14.68842,14.68842,0,0,0,14.68831,14.68831h81.971A14.68838,14.68838,0,0,0,540.276,154.97519V151.88h25.70651A17.83282,17.83282,0,0,1,583.82114,169.71864Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#00b0ff"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 331.56173,
  y: 151.41214,
  width: 182.71769,
  height: 88.99612,
  fill: "#3f3d56"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M467.61316,279.34269c4.78308,17.68113,21.16621,28.6315,21.16621,28.6315s8.62822-17.71641,3.84514-35.39754-21.1662-28.6315-21.1662-28.6315S462.83009,261.66156,467.61316,279.34269Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#fff"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M474.64156,275.54282c13.12484,12.7765,14.72794,32.417,14.72794,32.417s-19.67646-1.07435-32.8013-13.85085S441.84026,261.692,441.84026,261.692,461.51672,262.76632,474.64156,275.54282Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#00b0ff"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M511.12584,279.34269c-4.78308,17.68113-21.1662,28.6315-21.1662,28.6315s-8.62822-17.71641-3.84515-35.39754,21.16621-28.6315,21.16621-28.6315S515.90892,261.66156,511.12584,279.34269Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#fff"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M504.09744,275.54282c-13.12483,12.7765-14.72794,32.417-14.72794,32.417s19.67647-1.07435,32.8013-13.85085S536.89874,261.692,536.89874,261.692,517.22228,262.76632,504.09744,275.54282Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#00b0ff"
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 347.90393,
  y: 290.24551,
  width: 150.03328,
  height: 8.2358,
  fill: "#f0f0f0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 347.90393,
  y: 303.51429,
  width: 150.03328,
  height: 8.2358,
  fill: "#f0f0f0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 347.90393,
  y: 316.78308,
  width: 150.03328,
  height: 8.2358,
  fill: "#f0f0f0"
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 347.90393,
  y: 330.05186,
  width: 150.03328,
  height: 8.2358,
  fill: "#f0f0f0"
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 464.91681,
  y: 452.21328,
  width: 40.95397,
  height: 40.95397,
  transform: "translate(300.7344 -260.55228) rotate(35.37103)",
  fill: "#f0f0f0"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M489.93637,509.85093A9.45092,9.45092,0,1,1,499.38729,500.4,9.46174,9.46174,0,0,1,489.93637,509.85093Zm0-17.32668A7.87577,7.87577,0,1,0,497.81214,500.4,7.88454,7.88454,0,0,0,489.93637,492.52425Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#3f3d56"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M259.33971,84.6604V481.6697a17.83895,17.83895,0,0,1-17.83862,17.83073H80.32359A17.80758,17.80758,0,0,1,62.485,481.6697V84.6604A17.83785,17.83785,0,0,1,80.32359,66.82178h24.12346V69.917a14.68844,14.68844,0,0,0,14.68832,14.68832h81.971A14.68839,14.68839,0,0,0,215.79459,69.917V66.82178h25.7065A17.83282,17.83282,0,0,1,259.33971,84.6604Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#f2f2f2"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M238.89422,283.60275H81.379V142.62659H238.89422Zm-155.9401-1.57516H237.31906V144.20175H82.95412Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#3f3d56"
});

var _ref18 =
/*#__PURE__*/
React.createElement("rect", {
  x: 159.34895,
  y: 108.53222,
  width: 1.57527,
  height: 209.1649,
  transform: "translate(-167.9586 123.64721) rotate(-48.20522)",
  fill: "#3f3d56"
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 55.55414,
  y: 212.32703,
  width: 209.1649,
  height: 1.57527,
  transform: "translate(-163.76865 94.12913) rotate(-41.79384)",
  fill: "#3f3d56"
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 19.68152,
  y: 257.73493,
  width: 155.9401,
  height: 1.57515,
  fill: "#3f3d56"
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 19.68152,
  y: 271.91131,
  width: 155.9401,
  height: 1.57515,
  fill: "#3f3d56"
});

var _ref22 =
/*#__PURE__*/
React.createElement("rect", {
  x: 19.68152,
  y: 286.08768,
  width: 155.9401,
  height: 1.57515,
  fill: "#3f3d56"
});

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 19.68152,
  y: 300.26405,
  width: 77.97005,
  height: 1.57515,
  fill: "#3f3d56"
});

var _ref24 =
/*#__PURE__*/
React.createElement("rect", {
  x: 19.68152,
  y: 314.44042,
  width: 77.97005,
  height: 1.57515,
  fill: "#3f3d56"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M907.515,84.6604V481.6697a17.83895,17.83895,0,0,1-17.83862,17.83073H728.49886a17.80758,17.80758,0,0,1-17.83857-17.83073V84.6604a17.83785,17.83785,0,0,1,17.83857-17.83862h24.12346V69.917a14.68844,14.68844,0,0,0,14.68832,14.68832h81.971A14.68839,14.68839,0,0,0,863.96986,69.917V66.82178h25.7065A17.83282,17.83282,0,0,1,907.515,84.6604Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#f2f2f2"
});

var _ref26 =
/*#__PURE__*/
React.createElement("rect", {
  x: 669.43195,
  y: 203.39217,
  width: 155.9401,
  height: 1.57515,
  fill: "#3f3d56"
});

var _ref27 =
/*#__PURE__*/
React.createElement("rect", {
  x: 669.43195,
  y: 244.34614,
  width: 155.9401,
  height: 1.57515,
  fill: "#3f3d56"
});

var _ref28 =
/*#__PURE__*/
React.createElement("rect", {
  x: 669.43195,
  y: 285.3001,
  width: 155.9401,
  height: 1.57515,
  fill: "#3f3d56"
});

var _ref29 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 743.24177,
  cy: 117.99669,
  r: 25.60213,
  fill: "#00b0ff"
});

var _ref30 =
/*#__PURE__*/
React.createElement("rect", {
  x: 785.99323,
  y: 196.30398,
  width: 11.02607,
  height: 25.20244,
  fill: "#00b0ff"
});

var _ref31 =
/*#__PURE__*/
React.createElement("rect", {
  x: 689.12135,
  y: 236.47037,
  width: 11.02607,
  height: 25.20244,
  fill: "#00b0ff"
});

var _ref32 =
/*#__PURE__*/
React.createElement("rect", {
  x: 753.70261,
  y: 276.63676,
  width: 11.02607,
  height: 25.20244,
  fill: "#00b0ff"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M809.0879,213.50846a31.50305,31.50305,0,1,1,31.50305-31.503A31.5389,31.5389,0,0,1,809.0879,213.50846Zm0-61.431a29.9279,29.9279,0,1,0,29.9279,29.9279A29.96194,29.96194,0,0,0,809.0879,152.07751Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#3f3d56"
});

var _ref34 =
/*#__PURE__*/
React.createElement("rect", {
  x: 310.44646,
  y: 264.36769,
  width: 1.99985,
  height: 99.25679,
  transform: "translate(-191.11985 203.34606) rotate(-39.54617)",
  fill: "#3f3d56"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M350.73,361.57278c-5.24124-3.03781-12.50073-6.18243-18.21878-7.12585l9.52512-3.40314L347.179,342.336C347.02332,348.12924,348.7374,355.85263,350.73,361.57278Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#3f3d56"
});

var _ref36 =
/*#__PURE__*/
React.createElement("rect", {
  x: 608.16085,
  y: 312.99579,
  width: 99.25711,
  height: 2.0006,
  transform: "translate(-65.56767 554.6293) rotate(-50.46658)",
  fill: "#3f3d56"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M618.506,361.57278c1.99115-5.72137,3.70526-13.44476,3.54962-19.238l5.14411,8.709,9.52356,3.40189C631.00522,355.38913,623.7457,358.53372,618.506,361.57278Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#3f3d56"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1079.015,444.67822s0,146-23,199l-53,119s-34-2-36-16l40-124,24-73,6-114Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#2f2e41"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1046.015,448.67822l-9,61,6,134,3,74s12,33,8,36l-8,6s-32-4-33-6-20-153-20-153-39-122-37-124,11-32,11-32Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#2f2e41"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1053.015,749.67822l4,23s11,47,0,47-31-13-32-21,2-44,2-44Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#2f2e41"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1002.015,757.67822s8,16,13,18,27.77,15.08269,14.385,23.54135-27.385.45865-27.385.45865l-46-25s6-25,15-27S1002.015,757.67822,1002.015,757.67822Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#2f2e41"
});

var _ref42 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 929.52997,
  cy: 120.85644,
  r: 36,
  fill: "#ffb8b8"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1022.015,190.67822s7,46,14,52-15,27-25,26-21-23-21-23,3-29-2-37S1022.015,190.67822,1022.015,190.67822Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#ffb8b8"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1014.015,249.67822,1031,234a64.29232,64.29232,0,0,0,20.015,16.67822c13,7-25,79-25,79l-61-76s19.40212-12.89668,25.70106-17.94834Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#3f3d56"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1024.015,310.67822s26.80043-46.71919,23.90022-61.85959c0,0,39.09978,9.85959,41.09978,22.85959s-19,60-19,60,17,119,7,120-110,2-112-3,2-20-4-25-13-2-10-10,16-18,12-24-5-4-4-8-2-57-2-57-21-58-16-62,31.22757-13.85959,31.22757-13.85959Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#3f3d56"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1104.015,466.67822s-3,40-20,38,3-45,3-45Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#ffb8b8"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M955.015,465.67822s6,24,13,22v-28l-3-5Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#ffb8b8"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1021.37685,192.857a6.22218,6.22218,0,0,0-1.02654-2.895,4.69433,4.69433,0,0,0-2.18848-1.38668,9.8326,9.8326,0,0,0-11.71709,5.02134c-.9232,2.01357-1.36667,4.60676-3.392,5.50383-2.35413,1.0427-4.96552-1.177-5.89034-3.57987s-.94951-5.12616-2.18261-7.38639c-1.46216-2.68008-4.41787-4.25968-7.40447-4.8929-2.47494-.52474-5.50409-.79974-6.6204-3.0701a6.07775,6.07775,0,0,1-.45225-2.74409,28.964,28.964,0,0,1,1.78724-9.79156c-9.79684-1.95655-18.51144,7.60415-28.50055,7.75843a7.52545,7.52545,0,0,1-3.67552-.72036c-2.21649-1.18395-3.18-3.80837-3.84778-6.23091q-1.06388-3.85965-1.75106-7.81015L947.71427,162.1a12.55094,12.55094,0,0,1-1.42539-5.51247,13.19157,13.19157,0,0,1,4.918.41515l.23286-5.73423c2.47176,3.13416,7.40026,2.03252,11.11882.58172,7.17693-2.80009,14.31693-5.83072,21.84937-7.44661s15.6064-1.73478,22.729,1.20071c7.48528,3.08495,13.25637,9.22,18.3397,15.5213,2.81777,3.49289,5.54177,7.16384,7.06342,11.38577a27.59523,27.59523,0,0,1-.06014,17.60083c-1.63958,5.134-4.68808,11.34414-8.79152,14.9018C1022.25311,201.38,1022.05828,196.74447,1021.37685,192.857Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#2f2e41"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M953.015,259.67822l-13,3s-15,16-16,31-1,90-1,90l19,62s-2,14,0,14,3-3,3,1-5,0,0,4l10,8,16.71292-22.158s1.28708-8.842-1.71292-10.842-3-3-2-6,3-4,2-6-4-5-4-7,0-4-1-5-8-25-8-25l4-78Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#3f3d56"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1079.015,264.67822l10,5s16,48,16,90,3,70,3,70,5,12,3,12-4,0-2,3,3,2,2,5-2-2-1,3,0,7-2,7-2,13-2,13l-24-9s4-5,3-7a9.965,9.965,0,0,1-1-4s5-1,0-3-3-2-2-8,4-5,1-6-21-94-21-94Z",
  transform: "translate(-62.48502 -66.82178)",
  fill: "#3f3d56"
});

var _ref51 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 951.51498,
  cy: 183.17822,
  r: 3,
  fill: "#2f2e41"
});

var _ref52 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 951.51498,
  cy: 193.17822,
  r: 3,
  fill: "#2f2e41"
});

var SvgProjectCover6 = function SvgProjectCover6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "e07e5ae7-3299-40d2-9315-78b8b3e13d89",
    "data-name": "Layer 1",
    width: 1075.02997,
    height: 766.35644,
    viewBox: "0 0 1075.02997 766.35644",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProjectCover6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/projectCover6.4bc4db8d.svg";
export { ForwardRef as ReactComponent };